module.exports = __webpack_public_path__ + "img/103.11b5f0fc.png";